// extracted by mini-css-extract-plugin
export default {"refundedRedeemedVouchers":"sales-summary--refundedRedeemedVouchers--ab45f9","redeemedVouchers":"sales-summary--redeemedVouchers--c5b556"};